import React, { useState, useEffect } from "react";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useAlert } from "../../../context/AlertContext";

const AutoCompleteInput = ({
  clients,
  timeSlotId,
  renderClients,
  updateStateReservation,
}) => {
  const [clientsToAdd, setClientsToAdd] = useState([]);
  const { showAlert } = useAlert();
  const addBookingForClinet = async () => {
    try {
      const timeSlots = {
        client_id: clientsToAdd.id,
        status: "book",
        timeSlot_id: timeSlotId,
      };

      const data = {
        timeSlots: [timeSlots],
      };
      const response = await ApiMethods.post("auth/add_booking", data);
      renderClients();
      updateStateReservation();
    } catch (err) {
      console.log(err, "error");
      if (err?.code === "NO_AVAILABLE_PACKAGE") {
        showAlert(err.message, "error");
      } else {
        showAlert("Došlo je do greške pri zakazivanju termina", "error");
      }
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div style={{ position: "relative", display: "flex" }}>
        <Autocomplete
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.first_name} {option.last_name}
              </li>
            );
          }}
          options={Object.values(clients)}
          getOptionLabel={(option) =>
            `${option.first_name || ""} ${option.last_name || ""}`
          }
          renderInput={(params) => (
            <TextField {...params} label="Select Client" variant="outlined" />
          )}
          onChange={(event, value) => {
            setClientsToAdd(value);
          }}
        />
        <button
          onClick={() => addBookingForClinet()}
          className="button confirm-btn"
        >
          Potvrdi
        </button>
      </div>
    </div>
  );
};

export default AutoCompleteInput;
